/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { getUpdatedRolOnList, getUpdateRoles } from 'src/utils/permissions';
import { BaseAction } from '../../types/global.type';
import * as actions from '../../types/roles.type';

export type RolesState = {
  data: Array<any>,
  isSetting: boolean,
  error?: any,
  viewColumns?: Array<any>,
  all: Array<any>,
};

const initialState: RolesState = {
  data: [],
  isSetting: false,
  error: null,
  viewColumns: undefined,
  all: [],
}

export const rolesReducer = (
  state: RolesState = initialState,
  action: BaseAction
) => {
  let baseList:any = [];
  let currentList:any = [];
  switch (action.type) {
    case actions.GET_ROLES:
      return {...state, isSetting: true, error: null}
    case actions.GET_ROLES_SUCCESS:
      baseList = JSON.parse(JSON.stringify(state.all));
      currentList = getUpdateRoles(baseList, action?.payload?.roles, action?.payload?.serviceId, action?.payload?.licenseId);
      return {
        ...state,
        all: [...currentList],
        data: action.payload.roles,
        error: null,
        isSetting: false
      }
    case actions.GET_ROLES_FAILURE:
      return {...state, error: action.payload, data: [], isSetting: false}
    case actions.DELETE_ROL:
      return {...state, isSetting: true, error: null}
    case actions.DELETE_ROL_SUCCESS:
      baseList = JSON.parse(JSON.stringify(state.all));
      currentList = getUpdateRoles(baseList, action?.payload?.roles, action?.payload?.serviceId, action?.payload?.licenseId);
      return {
        ...state,
        all: [...currentList],
        data: action.payload?.roles,
        error: null,
        isSetting: false,
      }
    case actions.DELETE_ROL_FAILURE:
      return {...state, error: action.payload, isSetting: false}
    case actions.SET_VIEW_COLUMNS:
      return {
        ...state,
        viewColumns: action.payload.value
      };
    case actions.UPDATE_CURRENT_ROLES:
      return {
        ...state,
        data: action.payload
      };
    case actions.UPDATE_ROL_ON_LIST:
      baseList = JSON.parse(JSON.stringify(state.all));
      currentList = getUpdatedRolOnList(baseList, action?.payload?.role, action?.payload?.serviceId, action?.payload?.licenseId);
      return {
        ...state,
        all: [...currentList],
      };
    case actions.CLEAN_ROLES_ERRORS:
      return {...state, error: null}
    default:
      return state;
  }
};
